import script from "./AccessibilityLauncher.vue?vue&type=script&setup=true&lang=js"
export * from "./AccessibilityLauncher.vue?vue&type=script&setup=true&lang=js"

import "./AccessibilityLauncher.vue?vue&type=style&index=0&id=9d6dfa50&scoped=true&lang=css"
import "./AccessibilityLauncher.vue?vue&type=style&index=1&id=9d6dfa50&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9d6dfa50"]])

export default __exports__